import { styled } from "styled-components";

export const Fallback = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.error.default};
  color: ${({ theme }) => theme.colors.default[0]};
  font-family: "Courier New", Courier, monospace;
`;

export const Error = styled.div`
  background: ${({ theme }) => theme.colors.default.default};
  padding: 12px;
  border-radius: 4px;
`;
